import React from 'react';
import clsx from 'clsx';
import styles from './RequirementTabSelector.module.scss';

export interface TabItem {
    id: string;
    label: string;
    count?: number;
}

type RequirementTabSelectorProps = {
    tabs: TabItem[];
    activeTabId: string;
    onTabChange: (tabId: string) => void;
};

const RequirementTabSelector: React.FC<RequirementTabSelectorProps> = ({ tabs, activeTabId, onTabChange }) => {
    return (
        <div className={styles.TabSelector}>
            {tabs.map((tab) => (
                <div
                    key={tab.id}
                    onClick={() => onTabChange(tab.id)}
                    className={clsx({
                        [styles.Tab]: true,
                        [styles.Active]: activeTabId === tab.id,
                    })}
                >
                    {tab.label} {tab.count !== undefined && <span style={{ color: '#B4B4B4' }}>{tab.count}</span>}
                </div>
            ))}
        </div>
    );
};

export default RequirementTabSelector;
